import { Tag, Tooltip } from "antd";
import { TFeatureWorkflowInstance } from "entity-app/models";
import { InfoCircleOutlined } from "@ant-design/icons";

function EntityLeadTimeView(props: {
  featureWorkflowInstance: TFeatureWorkflowInstance;
  materialHeaderMap?: any;
}) {
  const { featureWorkflowInstance, materialHeaderMap } = props;
  if (!featureWorkflowInstance) return null;
  const leadTime =
    featureWorkflowInstance?.feature_workflow_instance?.lead_time;
  const dayPlaceholder = leadTime && leadTime > 1 ? "days" : "day";

  return (
    <div className="flex space-x-2 items-center text-ciq-gray-800 text-opacity-80 text-sm font-medium">
      <div>{materialHeaderMap?.lead_time ?? ""}:</div>
      <Tag className="rounded">
        <div className="flex space-x-2 items-center">
          <div className="space-x-[1px] text-black text-opacity-90 font-normal">
            <span>{leadTime}</span>
            <span className="italic">{dayPlaceholder}</span>
          </div>
          <Tooltip
            title="In Calendar days, including weekends and holidays."
            className="cursor-default"
            overlayStyle={{ maxWidth: "150px" }}
          >
            <InfoCircleOutlined style={{ color: "gray" }} />
          </Tooltip>
        </div>
      </Tag>
    </div>
  );
}

export default EntityLeadTimeView;
